export default "__VITE_ASSET__D7eQDK2H__"